import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyAjQQPvsUmrDDgx-axL8IclLMd0OF_jtnQ",
    authDomain: "please-be-true.firebaseapp.com",
    databaseURL: "https://please-be-true.firebaseio.com",
    projectId: "please-be-true",
    storageBucket: "please-be-true.appspot.com",
    messagingSenderId: "418984157518",
    appId: "1:418984157518:web:356dab3d467e45927efe1f",
    measurementId: "G-B5CNTSZSXR"
  };

// Load Firebase project configuration.
export const app = firebase.initializeApp(firebaseConfig);
export const auth = app.auth();
export const db = app.firestore();
export const increment = firebase.firestore.FieldValue.increment;
export const arrayUnion = firebase.firestore.FieldValue.arrayUnion;
export const arrayRemove = firebase.firestore.FieldValue.arrayRemove;

export const messaging = firebase.messaging();
messaging.usePublicVapidKey("BC5NS9DjvVtOp2bgBNRjsvmpTYdWMTZr0c_JweqNk7_UbAV7Hh7C3-z5Va-jM0mHDpbgV5XH-4JKcELaSBk2JX0");